import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllEvents } from '../../services/apiClient';
import type { Event } from '../../types';
import { formatShortDate } from '../../lib/formatting';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { Button } from '../../components/ui/Button';
import { EmptyState } from '../../components/ui/EmptyState';
import { DataTable, Column } from '../components/DataTable';
import styles from './ManageEvents.module.css';

export function ManageEvents() {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllEvents().then((r) => {
      if (r.data) setEvents(r.data);
      setLoading(false);
    });
  }, []);

  const columns: Column<Event>[] = [
    {
      key: 'title',
      label: 'Event',
      render: (evt) => (
        <div>
          <p className={styles.eventTitle}>{evt.title}</p>
          <p className={styles.eventSlug}>{evt.slug}</p>
        </div>
      ),
    },
    { key: 'type', label: 'Type', render: (evt) => <span className={styles.type}>{evt.type}</span> },
    { key: 'start_date', label: 'Date', render: (evt) => formatShortDate(evt.start_date) },
    { key: 'status', label: 'Status', render: (evt) => <StatusBadge label={evt.status} /> },
    {
      key: 'registration_open',
      label: 'Registration',
      render: (evt) => (
        <StatusBadge label={evt.registration_open ? 'open' : 'closed'} variant={evt.registration_open ? 'success' : 'neutral'} />
      ),
    },
    {
      key: 'actions',
      label: '',
      width: '80px',
      render: (evt) => (
        <Link to={`/admin/events/${evt.id}/edit`} className={styles.editLink}>
          Edit
        </Link>
      ),
    },
  ];

  return (
    <div className={styles.page}>
      <div className={styles.toolbar}>
        <p className={styles.count}>{events.length} event{events.length !== 1 ? 's' : ''}</p>
        <Link to="/admin/events/new">
          <Button size="sm">+ New Event</Button>
        </Link>
      </div>

      {loading ? (
        <p className={styles.loading}>Loading…</p>
      ) : events.length === 0 ? (
        <EmptyState
          title="No events yet"
          description="Create your first event to get started."
          action={<Link to="/admin/events/new"><Button>Create Event</Button></Link>}
        />
      ) : (
        <DataTable columns={columns} rows={events} keyField="id" />
      )}
    </div>
  );
}
